import {
    Box,
    Dialog,
    Slide,
    Divider,
} from "@mui/material";
import { useState, forwardRef } from "react";
import { Swiper, SwiperSlide, FreeMode } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import "swiper/swiper-bundle.css";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

SwiperCore.use([Pagination])

function ReviewReceiptHelp() {
    const [open, setOpen] = useState(false);

    return (
        <Box>
            <Dialog
                fullScreen
                open={open}
                onClose={() => setOpen(false)}
                TransitionComponent={Transition}
                >
                <Box
                    sx={{
                        width: '90%',
                        textAlign: 'left',
                        padding: '30px 0 10px 10px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }}>
                    <img src='/img/back_button_black.png' onClick={() => setOpen(false)} />
                    <Box
                        sx={{
                            margin: '16px 0 0 10px',
                            fontSize: '22px',
                            fontWeight: 'bold'
                        }}>
                        결제 영수증은 어디서 받을 수 있나요?
                    </Box>
                </Box>
                <Divider />
                <Swiper
                    grabCursor={true}
                    slidesPerView={1}
                    pagination={{ clickable: true }}
                    style={{
                        width: '100%',
                        height: '100%',
                        zIndex: 1,
                        overflow: 'scroll',
                    }}
                >
                    <SwiperSlide>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: '20px'
                            }}>
                            <Box
                                sx={{
                                    width: '70%',
                                    fontSize: '14px',
                                    marginBottom: '20px',
                                }}>
                                하단메뉴에서 내수업을 클릭합니다.
                            </Box>                        
                            <img src='/img/receipt_help01.png' width='70%' />
                        </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: '20px'
                            }}>
                            <Box
                                sx={{
                                    width: '70%',
                                    fontSize: '14px',
                                    marginBottom: '20px',
                                }}>
                                내수업 페이지에서 구매내역을 클릭합니다.
                            </Box>                        
                            <img src='/img/receipt_help02.png' width='70%' />
                        </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: '20px'
                            }}>
                            <Box
                                sx={{
                                    width: '70%',
                                    fontSize: '14px',
                                    marginBottom: '20px',
                                }}>
                                영수증보기 버튼을 클릭합니다.
                            </Box>                        
                            <img src='/img/receipt_help03.png' width='70%' />
                        </Box>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Box
                            sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                marginTop: '20px'
                            }}>
                            <Box
                                sx={{
                                    width: '70%',
                                    fontSize: '14px',
                                    marginBottom: '20px',
                                }}>
                                매출전표를 캡처 후 저장합니다. 캡처한 사진을 네이버 플레이스 게시물에 포함하여 올립니다.
                            </Box>                        
                            <img src='/img/receipt_help04.png' width='70%' />
                        </Box>
                    </SwiperSlide>
                </Swiper>
            </Dialog>
            <Box
                sx={{
                    fontSize: '12px',
                    color: '#1976d2',
                    width: 'fit-content'
                }}
                onClick={() => setOpen(true)}
                >
                (결제 영수증은 어디서 받을 수 있나요?)
            </Box>
        </Box>
    )
}

export default ReviewReceiptHelp;